import update from 'immutability-helper';
import { TabTileStateProps } from './TabTilePropsInterfaces';

const initialProperties = {
  selectedTabName: 'Tab - 1',
  selectedTabId: 1,
  nextTabId: 2,
  editTabName: false,
  previousTabId: 1,
  editingTabId: null,

  selectedTileName: 'Tile - 1',
  selectedTileId: 1,
  nextTileId: 2,
  editTileName: false,
  previousTileId: 1,
  editingTileId: null,

  dragging: false,
  chartPropUpdated: false,
  showDash: true,
  callQueryAPIDashboard: true,
  isDashboardTileSwitched: false,
  dashMode: 'Edit',
  dashGridSize: { x: null, y: null },

  columnsOnlyDisplay: false,
  showDataViewerBottom: true,
  selectedControlMenu: 'Charts',

  selectedDataSetList: [],
  tablesForSelectedDataSets: {},
  missingTablesFormDataSets: {},
  tvSettings: {
    selectedTabArray: [],
    transitionTime: 10, // default 10 seconds
    dataRefreshEnableds: true,
    dataRefreshUnit: 'Minutes' as 'Minutes' | 'Hours',
    dataRefreshTime: 60,
  },
};

const tabTilePropsReducer = (state: TabTileStateProps = initialProperties, action: any) => {
  switch (action.type) {
    case 'UPDATE_NEXT_TAB_ID':
      return { ...state, nextTabId: state.nextTabId + 1 };

    case 'SELECTED_TAB':
      return {
        ...state,
        selectedTabId: action.payload.tabId,
        selectedTabName: action.payload.tabName,
        showDash: action.payload.showDash,
        //when dashmode is undefined assign value as "Edit"(case: open new tab for first timme)
        dashMode: action.payload.dashMode ? action.payload.dashMode : 'Edit',
        callQueryAPIDashboard: true,
      };

    case 'UPDATE_SELECTED_TAB_NAME':
      return {
        ...state,
        selectedTabName: action.payload,
      };

    case 'SET_EDITING_TAB_ID':
      return {
        ...state,
        editingTabId: action.payload,
      };

    case 'SET_EDITING_TILE_ID':
      return {
        ...state,
        editingTileId: action.payload,
      };

    case 'SET_TV_SELECTED_TABS':
      return update(state, {
        tvSettings: {
          selectedTabArray: { $set: action.payload },
        },
      });
    case 'REMOVE_TV_SELECTED_TABS':
      return update(state, {
        tvSettings: {
          selectedTabArray: {
            $set: state.tvSettings.selectedTabArray.filter((id) => id !== action.payload),
          },
        },
      });

    case 'SET_TV_TRANSITION_TIME':
      return update(state, {
        tvSettings: {
          transitionTime: { $set: action.payload },
        },
      });

    case 'SET_TV_DATA_REFRESH_ENABLED':
      return update(state, {
        tvSettings: {
          dataRefreshEnableds: { $set: action.payload },
        },
      });

    case 'SET_TV_DATA_REFRESH_UNIT':
      return update(state, {
        tvSettings: {
          dataRefreshUnit: { $set: action.payload },
        },
      });

    case 'SET_TV_DATA_REFRESH_TIME':
      return update(state, {
        tvSettings: {
          dataRefreshTime: { $set: action.payload },
        },
      });

    case 'CALL_QUERY_API_DASHBOARD':
      return { ...state, callQueryAPIDashboard: action.payload };

    case 'LOAD_TAB_TILE_PROPS_FROM_PLAYBOOK':
      return {
        ...action.payload,
        // Preserve TV settings if not in playbook
        tvSettings: action.payload.tvSettings || state.tvSettings,
      };

    case 'RESET_TABTILE_PROPS':
      return initialProperties;

    case 'EDITING_TAB':
      return { ...state, editTabName: action.payload };

    case 'EDITING_TILE':
      return { ...state, editTileName: action.payload };

    case 'SELECTED_TILE':
      return {
        ...state,
        previousTabId: state.selectedTabId,
        previousTileId: state.selectedTileId,
        selectedTileName: action.payload.tileName,
        selectedTileId: action.payload.tileId,
        nextTileId: action.payload.nextTileId,
        showDash: action.payload.showDash !== undefined ? action.payload.showDash : state.showDash,
        dashMode: action.payload.dashMode !== undefined ? action.payload.dashMode : state.dashMode,
      };

    case 'SET_DRAGGING':
      return {
        ...state,
        dragging: action.payload,
      };

    case 'SET_TABLE':
      return { ...state, selectedTable: action.payload };

    case 'CHART_PROP_UPDATED':
      return { ...state, chartPropUpdated: action.payload };

    case 'SHOW_DASHBOARD':
      let prevTile = 0,
        prevTab = 0;

      if (!state.showDash && !action.payload) {
        prevTile = state.previousTileId;
        prevTab = state.previousTabId;
      }

      return {
        ...state,
        previousTileId: prevTile,
        previousTabId: prevTab,
        isDashboardTileSwitched: true,
        showDash: action.payload,
      };

    case 'SET_DASH_TILE_SWITCHED':
      return { ...state, isDashboardTileSwitched: action.payload };

    case 'SET_DASH_GRID_SIZE':
      return { ...state, dashGridSize: action.payload };

    case 'SET_SELECTED_DATASET_LIST':
      return {
        ...state,
        selectedDataSetList: [...state.selectedDataSetList, action.payload],
      };

    case 'TABLES_FOR_SELECTED_DATASETS':
      return update(state, { tablesForSelectedDataSets: { $merge: action.payload } });

    case 'TOGGLE_COLUMNS_ONLY_DISPLAY':
      return update(state, { columnsOnlyDisplay: { $set: action.payload } });

    case 'TOGGLE_SHOW_DATA_VIEWER_BOTTOM':
      return update(state, { showDataViewerBottom: { $set: action.payload } });

    case 'TOGGLE_DASH_MODE':
      return update(state, { dashMode: { $set: action.payload } });

    case 'SET_SELECTED_CONTROL_MENU':
      return update(state, { selectedControlMenu: { $set: action.payload } });

    case 'SET_MISSING_TABLES_FORM_DATASETS':
      return update(state, { missingTablesFormDataSets: { $set: action.payload } });

    default:
      return state;
  }
};

export default tabTilePropsReducer;
